import React from 'react';
import PropTypes from 'prop-types';
import {map, isEmpty, uniqueId} from 'lodash';
import {withRouter} from 'react-router-dom';

// college readiness
import PortfolioListItem from 'shared/portfolio/components/portfolio-list-item';
import 'stylesheets/components/college-success/portfolio-list.scss';

const propTypes = {
  portfolioItems: PropTypes.arrayOf(
    PropTypes.shape({
      subtitle: PropTypes.string,
      name: PropTypes.string.isRequired,
      handleRemove: PropTypes.func,
      editLink: PropTypes.string,
    })
  ),
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const PortfolioList = ({portfolioItems, location: {pathname}}) => {
  if (isEmpty(portfolioItems)) return null;

  return (
    <>
      <p className="college-success-title portfolio-list">Your Portfolio</p>
      {map(portfolioItems, ({subtitle, name, handleRemove, editLink}) => (
        <PortfolioListItem
          key={uniqueId('college-success-item-')}
          subtitle={subtitle}
          name={name}
          handleRemove={handleRemove}
          editLink={{pathname: pathname.concat(editLink), state: {skipScrolling: true}}}
        />
      ))}
    </>
  );
};

PortfolioList.propTypes = propTypes;

export default withRouter(PortfolioList);
